/*

//2015-11-11

ChangeLog:
	v2.3.0 R3 - 2018-02-06
		Text change
		
	v2.3.0 R2 - 2018-01-09
		Made the option "skipDisabled" enabled by default in order to comply with the way browsers interpret disabled elements
		NOTE: this is a breaking change!
		
	v2.3.0 - 2018-01-08
		Added support for skipping disabled items
		
	v2.2.0 - 2018-01-02
		Added support for returning the form default
		
	v2.1.0 R2 - 2017-07-19
		Added strict mode
		
	v2.1.0 - 2016-03-07
		Added option to only return data of the controls that has been changed
		
	v2.0.0 - 2015-11-12
		Complete rewrite of formToObj() to properly support MIME field names as objects and arrays
		Dropped the 'onlyChanged' option
		Dropped support for data-cbvalue and thus checkbox values as keys, instead following should be used for checkboxes if the key need to be the value, and the value should be true/false:
		<input type="checkbox" name="keyValueList[10]" />
		<input type="checkbox" name="keyValueList[32]" />
		<input type="checkbox" name="keyValueList[63]" />

*/

	/*

onlyChanged		Only return the fields that have been changed
formDefaults	Return the fields default values rather than their current values (not working for hidden inputs: https://stackoverflow.com/questions/5319678/javascript-and-defaultvalue-of-hidden-input-elements)
skipDisabled	Skip fields that are disabled (disabled="disabled")

*/
const formToObject = function(form, onlyChanged, formDefaults, skipDisabled)
{	//2015-11-11
	onlyChanged = !!onlyChanged;
	formDefaults = !!formDefaults;
	skipDisabled = (typeof(skipDisabled) === 'undefined'?true:!!skipDisabled);
	
	var elements = [];
	for(const elm of form.querySelectorAll('*'))
	{
		if(['INPUT', 'SELECT', 'TEXTAREA'].indexOf(elm.nodeName) !== -1)
		{
			elements.push(elm);
		}
		else
		{
			for(const elm2 of elm.querySelectorAll('input, select, textarea'))
			{
				elements.push(elm2);
			}
		}
	}
	
	var arraysEquals = function(a, b)
	{
		if(a.length != b.length) return false;
		
		for(var i=0;i<a.length;i++) if(a[i] != b[i]) return false;
		
		return true;
	};
	
	var getSelectValue = function(select, defaults, multiple)
	{	//2018-01-02
		var options = Array.from(select.options);
		multiple = !!multiple;
		
		if(options.length === 0) return null;
		
		var firstValue = null;
		var selectedValues = [];
		
		options.forEach((option, index) =>
		{
			var value = option.value;
			
			if(index === 0) firstValue = value;
			
			if(defaults)
			{
				if(option.defaultSelected) selectedValues.push(value);
			}
			else
			{
				if(option.selected) selectedValues.push(value);
			}
		});
		
		if(multiple)
		{
			return selectedValues.length === 0
				? null
				: selectedValues;
		}
		else
		{
			return selectedValues.length === 0
				? firstValue
				: selectedValues[selectedValues.length-1];
		}
	};
	
	var unique = (value, index, self) => { return self.indexOf(value) === index; };
	
	var object = {};
	elements.filter(unique).forEach(elem =>	//make sure that we only have one of each dom element before iterating them
	{
		if(!elem.name) return;	//we don't care about inputs without a name
		
		if(skipDisabled && elem.disabled) return;
		
		if(onlyChanged)
		{
			var changed = false;
			if(['checkbox', 'radio'].indexOf(elem.type) !== -1)
			{
				changed = (elem.defaultChecked != elem.checked);
			}
			else if(['INPUT', 'TEXTAREA'].indexOf(elem.nodeName) !== -1)
			{
				changed = elem.defaultValue != elem.value;
			}
			else if(elem.nodeName === 'SELECT' && elem.multiple)
			{
				var defaultValues = [];
				
				for(const opt of elem.options)
				{
					if(opt.defaultSelected === true) defaultValues.push(opt.value);
				};
				
				var selectValue = elem.value === null ? [] : elem.value;
				
				changed = !arraysEquals(defaultValues, selectValue);
			}
			else if(elem.nodeName === 'SELECT')
			{
				var defaultOption = null;
				
				for(const opt of elem.options)
				{
					if(opt.defaultSelected === true) defaultOption = opt;
				};
				
				if(defaultOption === null) defaultOption = elem.options[0];
				
				changed = (defaultOption.value != elem.value);
			}
			else
			{
				console.log(elem);
				throw 'formToObject(): Unknown control (dumped to console)';
			}
			
			if(!changed) return;
		}
		
		var name = elem.name;
		var nameParts = name.match(/^([^\[]+)(.*)$/);
		
		if(nameParts === null || nameParts.length !== 3) throw 'formToObject(): Failed to parse name "'+name+'"';
		
		var baseName = nameParts[1];
		var path = nameParts[2];
		var pathParts;
		
		var contextIndex = baseName;
		var context = object;
		
		if(typeof(context[contextIndex]) === 'undefined') context[contextIndex] = null;
		
		if(path !== '')
		{
			if(path.match(/^(\[[^\[\]]*\])+$/) === null) throw 'Malformed field path "'+path+'"';
			
			pathParts = path.match(/\[([^\]]*)\]/g);
			
			pathParts.forEach(function(pathPartString, pathIndex)
			{
				var pathIsLast = ((pathIndex+1) === pathParts.length);
				
				var pathPart = pathPartString.match(/^\[([0-9]*)\]$/);
				
				if(pathPart !== null && (context[contextIndex] === null || typeof(context[contextIndex].length) !== 'undefined'))	//if the target container is (assumed to be) an array (and the context hasn't been converted to an object)
				{
					if(context[contextIndex] === null) context[contextIndex] = [];
					
					if(pathPart[1] === '')	//we need to push (arr[] = 'val')
					{
						if(pathIsLast)		//we don't to push/create the index in the array, if it is the inner-most index, as we would like to control this when adding the value
						{
							var index = context[contextIndex].length;
						}
						else
						{
							context[contextIndex].push(null);
							
							var index = (context[contextIndex].length-1);
						}
					}
					else	//we need to insert the value at the given index (arr[n] = 'val')
					{
						var index = parseInt(pathPart[1], 10);
						
						if(typeof(context[contextIndex][index]) === 'undefined')
						{
							if(index > context[contextIndex].length)		//if we are trying to insert an index into the array that is out of range/order, then we will assume that an object with numeric keys is what is wanted, thus convert the context to an object
							{
								var newObject = {};
								context[contextIndex].forEach(function(value, index)
								{
									newObject[index.toString()] = value;
								});
								
								context[contextIndex] = newObject;
							}
							
							context[contextIndex][index] = null;
						}
					}
				}
				else	//target container is an object
				{
					if(context[contextIndex] === null) context[contextIndex] = {};
					
					var index = pathPartString.substr(1, (pathPartString.length-2));
					
					if(typeof(context[contextIndex][index]) === 'undefined') context[contextIndex][index] = null;
				}
				
				context = context[contextIndex];
				contextIndex = index;
			});
		}
		
		var nameType = 'plain';	//if the name is supposed to hit a specific point in the object ("name" and "name[0][abc]" qualifies)
		if(path !== '' && pathParts[(pathParts.length-1)] === '[]') nameType = 'array';		//for every name ending in '[]'
		
		var isChecked = (['radio', 'checkbox']).indexOf(elem.type) !== -1 && elem.checked;
		
		if(elem.type === 'checkbox')
		{
			if(formDefaults) isChecked = elem.defaultChecked;
			
			if(nameType === 'plain')
			{
				context[contextIndex] = isChecked;
			}
			else if(nameType === 'array')
			{
				if(isChecked) context[contextIndex] = elem.value;
			}
		}
		else if(elem.type === 'radio')
		{
			if(formDefaults) isChecked = elem.defaultChecked;
			
			if(typeof(context[contextIndex]) === 'undefined') context[contextIndex] = null;
			
			if(isChecked) context[contextIndex] = elem.value;
		}
		else if(elem.nodeName === 'SELECT')
		{
			context[contextIndex] = getSelectValue(elem, formDefaults, elem.multiple) || [];
		}
		else if(['INPUT', 'TEXTAREA'].indexOf(elem.nodeName) !== -1)
		{
			context[contextIndex] = elem.value;
			
			if(formDefaults) context[contextIndex] = elem.defaultValue;
		}
		else
		{
			throw 'Unsupported form element: '+elem.nodeName;
		}
	});
	
	return object;
};


export default formToObject;